module.exports = __webpack_public_path__ + "media/Loops 90 Bass.3df03164.wav";